module.exports = __webpack_public_path__ + "img/l_hj.8493fafd.png";